function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closeGdpr } from "@common/actions/modals";
import { KEY_ESCAPE } from "@config/constants";
import React, { Component } from "react";
import { connect } from "react-redux";
var Gdpr = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Gdpr, Component);
    var _super = _create_super(Gdpr);
    function Gdpr(props) {
        _class_call_check(this, Gdpr);
        var _this;
        _this = _super.call(this, props);
        _this.wrapperRef = null;
        _this.setWrapperRef = _this.setWrapperRef.bind(_assert_this_initialized(_this));
        _this.handleClickOutside = _this.handleClickOutside.bind(_assert_this_initialized(_this));
        _this.closeFromKeyboard = _this.closeFromKeyboard.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(Gdpr, [
        {
            /**
     * Sets ref on the modal wrapper
     * @param {Object} node
     */ key: "setWrapperRef",
            value: function setWrapperRef(node) {
                this.wrapperRef = node;
            }
        },
        {
            /**
     * Closes the modal on escape keydown
     * @param {Object} event
     */ key: "closeFromKeyboard",
            value: function closeFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_ESCAPE) {
                    event.stopPropagation();
                    this.props.closeGdpr();
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("mousedown", this.handleClickOutside);
                this.wrapperRef.focus();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleClickOutside);
            }
        },
        {
            /**
     * Closes the modal on click outside of the modal wrapper
     * @param {Object} event
     */ key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                    this.props.closeGdpr();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, i18n = _this_props.i18n, _$closeGdpr = _this_props.closeGdpr, modal = _this_props.modal;
                return /*#__PURE__*/ _jsx("div", {
                    className: "modal-overlay gdpr-overlay",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "modal gdpr-modal-wrapper",
                        onKeyDown: this.closeFromKeyboard,
                        tabIndex: "0",
                        ref: this.setWrapperRef,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "modal-header",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "modal-title",
                                        children: i18n.gdpr[modal.gdprModalName]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        onClick: _$closeGdpr,
                                        className: "icon icon-clear pointer"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "modal-content",
                                dangerouslySetInnerHTML: {
                                    __html: i18n.gdpr["".concat(modal.gdprModalName + "Message")]
                                }
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return Gdpr;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, modal = param.modal, screenType = param.screenType;
    return {
        i18n: i18n,
        modal: modal,
        screenType: screenType
    };
};
export default connect(mapStateToProps, {
    closeGdpr: closeGdpr
})(Gdpr);
